import React from 'react';
import { MaskedLines, Reveal } from './reveal';
import { trackEvent } from '../../lib/track';

// TODO: verify final spec values with production build.
const SPECS = [
  { label: 'Drive Mode', value: 'Pneumatic Lift & Drop' },
  { label: 'Air Requirement', value: '100+ PSI Shop Compressor' },
  { label: 'Frame Material', value: 'Fully Galvanized Steel' },
  { label: 'Controller', value: 'Off-Hammer Proprietary "Black Box"' },
  { label: 'Piling Compatibility', value: 'Up to 12" Standard Piles' },
  { label: 'Electronics Warranty', value: '1 Year' },
  { label: 'Origin', value: 'Fort Myers, FL · U.S.A.' },
  { label: 'Shipping', value: 'Nationwide (Lower 48)' },
];

export default function HammerSpecs() {
  return (
    <section
      id="hammer-specs"
      data-testid="hammer-specs-section"
      className="relative bg-[#050608] border-t border-white/5 py-16 sm:py-20 lg:py-28 overflow-hidden"
    >
      <div className="relative max-w-6xl mx-auto px-5 sm:px-6 lg:px-10">
        <div className="max-w-3xl">
          <Reveal>
            <div className="flex items-center gap-3 mb-3 sm:mb-4">
              <span className="h-px w-8 sm:w-10 bg-cyan-400" />
              <span className="font-tech text-cyan-300 text-[10px] sm:text-[11px] uppercase tracking-[0.28em]">
                Features & Specifications
              </span>
            </div>
          </Reveal>
          <h2 className="font-display text-white text-3xl sm:text-4xl md:text-5xl font-bold uppercase leading-[1.02] tracking-tight">
            <MaskedLines
              delay={0.15}
              lines={[
                'Our Hammer',
                <span className="text-cyan-300">in Numbers.</span>,
              ]}
            />
          </h2>
        </div>

        <div className="mt-10 sm:mt-14 grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10 lg:gap-12 items-stretch">
          {/* Left: hammer portrait with vertical label — matches the barges page layout */}
          <Reveal delay={0.15} className="md:col-span-4 relative order-1 min-h-[360px] md:min-h-0">
            <div className="hidden md:flex absolute -left-2 top-2 flex-col items-center gap-3 z-10">
              <span className="h-14 w-px bg-gradient-to-b from-cyan-400 to-transparent" />
              <span
                className="font-tech text-[10px] tracking-[0.32em] text-cyan-300/80 uppercase"
                style={{ writingMode: 'vertical-rl', transform: 'rotate(180deg)' }}
              >
                Proprietary · Built In-House
              </span>
            </div>
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
              <div className="w-[45%] h-[45%] rounded-full bg-cyan-500/10 blur-[70px]" />
            </div>
            <div className="md:absolute md:inset-0 flex items-center justify-center h-full">
              <img
                src="/assets/absolute_hammer.webp?v=3"
                alt="The Absolute Hammer — proprietary pneumatic pile driving hammer"
                className="relative max-h-[440px] w-auto md:max-h-none md:h-full md:w-full object-contain"
                style={{ filter: 'drop-shadow(0 20px 60px rgba(34,211,238,0.28))' }}
                data-testid="hammer-specs-image"
              />
            </div>
          </Reveal>

          {/* Right: spec sheet + price */}
          <div className="md:col-span-8 order-2 flex flex-col gap-8 sm:gap-10">
            <Reveal delay={0.25} className="panel rounded-xl overflow-hidden">
              <dl className="divide-y divide-white/5">
                {SPECS.map((s, idx) => (
                  <div
                    key={s.label}
                    className="grid grid-cols-1 sm:grid-cols-3 gap-2 sm:gap-6 px-5 sm:px-8 py-4 sm:py-5 items-baseline"
                    data-testid={`hammer-spec-${idx}`}
                  >
                    <dt className="font-tech text-cyan-300/80 text-[11px] uppercase tracking-[0.24em]">
                      {s.label}
                    </dt>
                    <dd className="sm:col-span-2 text-zinc-200 text-sm sm:text-base font-medium">
                      {s.value}
                    </dd>
                  </div>
                ))}
              </dl>
            </Reveal>

            <Reveal
              delay={0.35}
              className="panel rounded-xl p-6 sm:p-8 md:p-10 flex flex-col md:flex-row md:items-center md:justify-between gap-5"
            >
              <div>
                <div className="font-tech text-cyan-300 text-[10px] sm:text-[11px] uppercase tracking-[0.28em] mb-1">
                  Sticker Price
                </div>
                <div className="font-display text-white text-4xl sm:text-5xl font-bold tracking-tight">
                  $10,500<span className="text-cyan-300">*</span>
                </div>
                <div className="mt-2 text-zinc-500 text-sm">
                  <span className="text-cyan-300">*</span> Does not include shipping (quoted separately)
                </div>
              </div>
              <a
                href="#hammer-quote"
                onClick={() => trackEvent('buy_click', { location: 'specs' })}
                data-testid="hammer-specs-buy-btn"
                className="btn-teal px-6 py-3 rounded-md text-xs sm:text-sm uppercase tracking-[0.16em] sm:tracking-[0.18em] whitespace-nowrap"
              >
                Buy Now
              </a>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
